import React, { Component } from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import downArrow from "../../assets/images/svg/down-arrow.svg";
import signout from "../../assets/images/svg/Signout.svg";
import profile from "../../assets/images/png/icons8-customer-64.png";
import SOSTOSLogo from "../../assets/images/svg/Sostoslogo.svg";
import videoplay from "../../assets/images/png/videoplay.png";
import contactus from "../../assets/images/png/contactus.png";
import { Link } from "react-router-dom";
import {
  setloginDetails,
  setupgradePopup,
  setlogoutPopup,
  setCancerType,
} from "../../reducers/counterSlice";
import { connect } from "react-redux";
import { AiOutlineDownload, AiOutlinePrinter } from "react-icons/ai";
import eventEmitter from "../ReusableComponent/EventEmitter";
import SweetAlert from "react-bootstrap-sweetalert";
import DiscoverDropdown from "./DiscoverDropdown";
import axiosInstance from "../configuration/Request";
import { showSuccessToast, showErrorToast } from "../Components/Toaster";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const dropdownMenuStyle = {
  width: "200px",
  maxHeight: "300px",
  overflowY: "auto",
};

const arrowRotateStyle = {
  transform: "rotate(180deg)",
};

const buttonStyles = {
  backgroundColor: "transparent",
  color: "inherit",
  ":hover": {
    backgroundColor: "transparent",
    color: "inherit",
  },
  ":active": {
    backgroundColor: "transparent",
    color: "inherit",
  },
  ":focus": {
    backgroundColor: "transparent",
    color: "inherit",
  },
};

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};
const mapDispatchToProps = {
  setloginDetails,
  setupgradePopup,
  setlogoutPopup,
  setCancerType,
};

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      userName: props?.reduxData?.loginDetails?.user?.username,
      printAndDownloadVisibilty:
        props.location?.pathname.includes("drugpage") ?? false,
      activePlanDetails: {},
      upgradePopup: props?.reduxData?.upgradePopup ?? true,
      logoutPopup: props?.reduxData?.logoutPopup ?? false,
      showVideoPopup: false,
      discoverDropdownOpen: false,
      nestedDropdownOpen: false,
      contactModal: false,
      contactForm: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      contactErrors: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      isSubmittingContact: false,
    };
  }

  componentDidMount() {
    const loginSubs = this.props?.reduxData?.loginSubscriptionDetail || [];
    const highestIdObject = loginSubs.find(item => item.attributes?.active === true) || { id: 0 };

    this.setState({ activePlanDetails: highestIdObject }, () => {
      // For Bronze users, if upgradePopup is true, show video automatically
      if (this.state.activePlanDetails?.attributes?.plan?.toLowerCase() === 'bronze' && this.props?.reduxData?.upgradePopup) {
        this.setState({ showVideoPopup: true });
        this.props?.setupgradePopup(false);
      }
    });
    window.showLogoutPopup = this.showLogoutPopup;
    eventEmitter.on("openContactModal", this.toggleContactModal);
  }

  componentWillUnmount() {
    eventEmitter.removeListener("openContactModal", this.toggleContactModal);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;

    if (location?.pathname !== prevProps.location?.pathname) {
      const shouldShowPrintAndDownload =
        location?.pathname.includes("drugpage") ?? false;

      if (this.state.printAndDownloadVisibilty !== shouldShowPrintAndDownload) {
        this.setState({
          printAndDownloadVisibilty: shouldShowPrintAndDownload,
        });
      }
    }

    if (this.props?.reduxData?.upgradePopup && !prevProps.reduxData?.upgradePopup) {
      this.setState({ showVideoPopup: true });
      this.props?.setupgradePopup(false);
    }
  }

  showLogoutPopup = () => {
    this.setState({ logoutPopup: true });
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  onLogoutClicked = () => {
    this.props?.setloginDetails("");
  };

  handlePrint = () => {
    eventEmitter.emit("callhandlePrintPDF");
  };

  handleDownloadPDF = () => {
    eventEmitter.emit("callhandleDownloadPDF");
  };

  handleTreatmentRankingClick = () => {
    this.props.setCancerType(this.props?.reduxData?.cancerType || {});
  };

  linkStyle = (isSelected) => ({
    fontWeight: isSelected ? "bold" : "normal",
    color: isSelected ? "#434aad" : "inherit",
    borderBottom: isSelected ? "2px solid #434aad" : "none",
    borderRadius: isSelected ? "1px" : "none",
    padding: isSelected ? "12px 2px" : "none",
  });

  toggleContactModal = () => {
    this.setState((prevState) => ({
      contactModal: !prevState.contactModal,
      contactForm: { name: "", email: "", subject: "", message: "" },
      contactErrors: { name: "", email: "", subject: "", message: "" },
    }));
  };

  handleContactChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => ({
        contactForm: { ...prevState.contactForm, [name]: value },
      }),
      () => this.validateContactField(name, value)
    );
  };

  validateContactField = (name, value) => {
    let error = "";
    if (!value.trim()) {
      error = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    } else {
      if (name === "email") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          error = "Please enter a valid email address";
        }
      } else if (name === "subject") {
        if (value.length > 100) {
          error = "Subject cannot exceed 100 characters";
        }
      } else if (name === "message") {
        const words = value.trim().split(/\s+/).length;
        if (words > 1000) {
          error = "Message cannot exceed 1000 words";
        }
      }
    }
    this.setState((prevState) => ({
      contactErrors: { ...prevState.contactErrors, [name]: error },
    }));
  };

  isContactFormValid = () => {
    const { contactForm, contactErrors } = this.state;
    const allFieldsFilled = Object.values(contactForm).every((val) => val.trim() !== "");
    const noErrors = Object.values(contactErrors).every((err) => err === "");
    return allFieldsFilled && noErrors;
  };

  handleOpenVideoPopup = () => {
    this.setState({ showVideoPopup: true, dropdownOpen: false });
  };

  handleContactSubmit = async () => {
    if (!this.isContactFormValid()) return;

    this.setState({ isSubmittingContact: true });
    try {
      const payload = {
        data: {
          name: this.state.contactForm.name,
          email: this.state.contactForm.email,
          subject: this.state.contactForm.subject,
          message: this.state.contactForm.message,
        },
      };

      await axiosInstance.post(
        `api/contact-uses`,
        payload
      );
      showSuccessToast("Message sent successfully!");
      this.toggleContactModal();
    } catch (error) {
      console.error("Contact API error:", error);
      showErrorToast("Failed to send message. Please try again later.");
    } finally {
      this.setState({ isSubmittingContact: false });
    }
  };

  render() {
    const { dropdownOpen, userName, printAndDownloadVisibilty, activePlanDetails, contactModal, contactForm, contactErrors, isSubmittingContact } = this.state;
    const isBiomarkerDiscovery = this.props.location?.pathname === '/app/biomarker-drug-discovery';
    return (
      <>
        <div className="header-container">
          <div className="header-leftContent">
            <div className="header-logo">
              <Link
                className="btn-link-primary"
                to={{ pathname: `/app/dashboard` }}
              >
                <img src={SOSTOSLogo} alt="" style={{ width: "120px" }} />
              </Link>
            </div>
            <div style={{ height: "65px", display: "flex", alignItems: "center" }}>
              {!this.props.location?.pathname.includes("dashboard") && (
                <div className="header-nav d-flex align-items-center">
                  {/* 1. Drug Repositioning Database */}
                  <div
                    className={`header-search ${!isBiomarkerDiscovery && (this.props?.location?.pathname?.includes("cancer") ||
                      this.props?.location?.pathname?.includes("drug"))
                      ? "header-search-active"
                      : ""
                      }`}
                  >
                    <Link
                      className="btn-link-primary"
                      to={{ pathname: `/app/cancerType` }}
                    >
                      <span className="header-nav-label">
                        Drug Repositioning Database
                      </span>
                    </Link>
                  </div>
                  {/* 2. Treatment Ranking */}
                  <Link
                    className={`header-search ${this.props?.location?.pathname?.includes("cancerTypeSelection")
                      ? "header-search-active"
                      : ""
                      }`}
                    to={{
                      pathname: "/app/cancerTypeSelection",
                      state: { openAdvancedSearch: true },
                    }}
                    onClick={this.handleTreatmentRankingClick}
                  >
                    <span className="btn-link-primary header-nav-label">
                      Treatment Ranking
                    </span>
                  </Link>
                  {/* 3. Multi... (Discover Dropdown) */}
                  <div
                    className={`header-search ${this.props?.location?.pathname?.includes("discover")
                      ? "header-search-active"
                      : ""
                      }`}
                  >
                    <DiscoverDropdown
                      location={this.props?.location?.pathname}
                    />
                  </div>
                  {/* 4. Biomarker Browser */}
                  <div
                    className={`header-search ${isBiomarkerDiscovery || this.props?.location?.pathname?.includes("bioMarker")
                      ? "header-search-active"
                      : ""
                      }`}
                  >
                    <Link
                      className="btn-link-primary"
                      to={{ pathname: `/app/bioMarker` }}
                    >
                      <span className="header-nav-label">
                        Biomarker Browser
                      </span>
                    </Link>
                  </div>
                  {/* 5. Population Projection */}
                  <Link
                    className={`header-search ${this.props?.location?.pathname?.includes("populationProjection")
                      ? "header-search-active"
                      : ""
                      }`}
                    to={{ pathname: "/app/populationProjection" }}
                  >
                    <span className="btn-link-primary header-nav-label">
                      Population Projection
                    </span>
                  </Link>
                  {/* 6. Forum */}
                  <div
                    className={`header-search ${this.props?.location?.pathname
                      ?.toLowerCase()
                      ?.includes("forum")
                      ? "header-search-active"
                      : ""
                      }`}
                  >
                    <Link
                      className="btn-link-primary"
                      to={{ pathname: `/app/forum` }}
                    >
                      <span className="header-nav-label">Forum</span>
                    </Link>
                  </div>
                  {/* AI Agent - commented out, will be enabled in future */}
                  {/* <div
                    className={`header-search ${this.props?.location?.pathname
                      ?.toLowerCase()
                      ?.includes("aillmagent")
                      ? "header-search-active"
                      : ""
                      }`}
                  >
                    <Link
                      className="btn-link-primary"
                      to={{ pathname: `/app/aiLlmAgent` }}
                    >
                      <span style={{ fontSize: "1rem" }}>AI Agent</span>
                    </Link>
                  </div> */}
                </div>
              )}
            </div>
          </div>
          <div className="header-rightContent d-flex gap-4">
            {/* Subscription_Commented_Code */}
            {/* Uncomment this Subscription_Commented_Code */}
            {activePlanDetails?.attributes?.plan?.toLowerCase() === 'bronze' &&
              <div>
                <Link
                  to={{
                    pathname: '/app/profileEdit',
                    state: { param: 'billing' }
                  }}
                >
                  <Button className="w-100" color="primary" style={{ borderRadius: '22px', height: '40px', fontSize: '1rem' }} >
                    Subscribe Now
                  </Button>
                </Link>
              </div>
            }
            <div>
              {/* <Button
                className="w-100"
                color="primary"
                style={{ borderRadius: "22px", height: "40px", fontSize: "1rem" }}
                onClick={this.toggleContactModal}
              >
                Contact Us
              </Button> */}
            </div>
            {printAndDownloadVisibilty && (
              <div className="d-flex gap-2">
                <div className="AiOutlineBackground">
                  <AiOutlineDownload
                    size={"1rem"}
                    onClick={this.handleDownloadPDF}
                  />
                </div>
                {printAndDownloadVisibilty && (
                  <div className="AiOutlineBackground">
                    <AiOutlinePrinter
                      size={"1rem"}
                      onClick={this.handlePrint}
                    />
                  </div>
                )}
              </div>
            )}

            <div>
              <Dropdown isOpen={dropdownOpen} toggle={this.toggleDropdown}>
                <DropdownToggle
                  tag="div"
                  data-toggle="dropdown"
                  aria-expanded={dropdownOpen}
                >
                  <Button
                    className="header-rightContent-user"
                    style={buttonStyles}
                  >
                    <div className="header-rightContent-userNameInitial">
                      {userName?.substring(0, 1)}
                      {/* Subscription_Commented_Code */}
                      {/* Uncomment this Subscription_Commented_Code */}
                      {/* {activePlanDetails?.attributes?.plan?.toLowerCase() === 'silver' && <img src={SilverCrown} alt="Crown" className="crown-icon" />}
                      {activePlanDetails?.attributes?.plan?.toLowerCase() === 'gold' && <img src={GoldCrown} alt="Crown" className="crown-icon" />} */}
                    </div>
                    <div className="header-rightContent-userName">
                      {userName}
                    </div>
                    <div>
                      <img
                        src={downArrow}
                        alt=""
                        style={{
                          width: "10px",
                          ...(dropdownOpen ? arrowRotateStyle : {}),
                        }}
                      />
                    </div>
                  </Button>
                </DropdownToggle>
                <DropdownMenu style={dropdownMenuStyle}>
                  <Link to={{ pathname: "/app/profileEdit" }}>
                    <DropdownItem>
                      <div className="d-flex">
                        <div>
                          <img
                            src={profile}
                            alt=""
                            style={{
                              width: "20px",
                            }}
                          />
                        </div>
                        <div
                          className="Over-Flow-Item"
                          style={{ paddingLeft: "8px" }}
                        >
                          Edit Profile
                        </div>
                      </div>
                    </DropdownItem>
                  </Link>
                  <DropdownItem onClick={this.handleOpenVideoPopup}>
                    <div className="d-flex">
                      <div>
                        <img
                          src={videoplay}
                          alt=""
                          style={{ width: "20px" }}
                        />
                      </div>
                      <div className="Over-Flow-Item" style={{ paddingLeft: "8px" }}>
                        Introduction Video
                      </div>
                    </div>
                  </DropdownItem>
                  <Link to={{ pathname: "/" }}>
                    <DropdownItem onClick={this.onLogoutClicked}>
                      <div className="d-flex">
                        <div>
                          <img
                            src={signout}
                            alt=""
                            style={{
                              width: "23px",
                              height: "15px",
                            }}
                          />
                        </div>
                        <div
                          className="Over-Flow-Item"
                          style={{ paddingLeft: "6px" }}
                        >
                          Sign Out
                        </div>
                      </div>
                    </DropdownItem>
                  </Link>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>

        {/* <SweetAlert
          show={this.state.upgradePopup}
          custom
          showCancel
          showCloseButton
          confirmBtnText="Upgrade Subscription"
          cancelBtnText="No"
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="light"
          onConfirm={() => {
            this.setState({ upgradePopup: false });
            this.props.history.push({
              pathname: "/app/profileEdit",
              state: { param: "billing" },
            });
            this.props?.setupgradePopup(false);
          }}
          onCancel={() => {
            this.setState({ upgradePopup: false, showVideoPopup: true });
          }}
        >
          Upgrade to premium subscription plan to access the data without any
          limitations.!
        </SweetAlert> */}
        <SweetAlert
          show={this.state.showVideoPopup}
          custom
          showConfirm={false}
          showCloseButton
          onConfirm={() => {
            this.setState({ showVideoPopup: false });
            this.props?.setupgradePopup(false);
          }}
          onCancel={() => {
            this.setState({ showVideoPopup: false });
            this.props?.setupgradePopup(false);
          }}
          style={{ width: '60%', maxWidth: '800px' }}
        >
          <div className="video-container">
            <video width="100%" controls autoPlay>
              <source src={require('../../assets/videos/video_1.mp4')} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </SweetAlert>
        <SweetAlert
          show={this.state?.logoutPopup}
          style={{ width: "550px" }}
          title="Oops! Your session timed out."
          confirmBtnText="Sign Back In"
          onConfirm={() => {
            this.setState({ logoutPopup: false });
            this.props.history.push({ pathname: "/auth/login" });
            this.props?.setlogoutPopup(false);
          }}
          onCancel={() => {
            this.setState({ logoutPopup: false });
            this.props.history.push({ pathname: "/auth/login" });
            this.props?.setlogoutPopup(false);
          }}
        >
          It looks like you've been inactive for a while. To keep your account
          secure, we've logged you out. Please log in to pick up where you left
          off.
        </SweetAlert>

        <Modal isOpen={contactModal} toggle={this.toggleContactModal} centered size="md">
          <ToastContainer />
          <ModalHeader toggle={this.toggleContactModal}>
            <div style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>Contact Us</div>
            <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '5px' }}>
              Share your question or feedback and our team will get back to you at the email you provide.
            </div>
          </ModalHeader>
          <ModalBody>
            <FormGroup ghost>
              <Label for="name" style={{ fontWeight: '500' }}>Name</Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Enter your full name"
                value={contactForm.name}
                onChange={this.handleContactChange}
                invalid={!!contactErrors.name}
              />
              <FormFeedback>{contactErrors.name}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <div className="d-flex justify-content-between align-items-center">
                <Label for="email" style={{ fontWeight: '500' }}>Email</Label>
                <div style={{ fontSize: '0.75rem', color: '#888' }}>Must be a valid email address (e.g., name@company.com).</div>
              </div>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="name@company.com"
                value={contactForm.email}
                onChange={this.handleContactChange}
                invalid={!!contactErrors.email}
              />
              <FormFeedback>{contactErrors.email}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <div className="d-flex justify-content-between align-items-center">
                <Label for="subject" style={{ fontWeight: '500' }}>Subject</Label>
                <div style={{ fontSize: '0.75rem', color: '#888' }}>Up to 100 characters.</div>
              </div>
              <Input
                type="text"
                name="subject"
                id="subject"
                placeholder="Briefly summarise your request"
                value={contactForm.subject}
                onChange={this.handleContactChange}
                invalid={!!contactErrors.subject}
              />
              <FormFeedback>{contactErrors.subject}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <div className="d-flex justify-content-between align-items-center">
                <Label for="message" style={{ fontWeight: '500' }}>Message</Label>
                <div style={{ fontSize: '0.75rem', color: '#888' }}>Up to 1000 words. Include relevant project or dataset details.</div>
              </div>
              <Input
                type="textarea"
                name="message"
                id="message"
                rows="4"
                placeholder="Describe your question, issue, or idea in detail."
                value={contactForm.message}
                onChange={this.handleContactChange}
                invalid={!!contactErrors.message}
              />
              <FormFeedback>{contactErrors.message}</FormFeedback>
            </FormGroup>

            {(contactErrors.email || contactErrors.subject || contactErrors.message) && (
              <div style={{
                backgroundColor: '#ffcc00',
                padding: '10px',
                borderRadius: '4px',
                fontSize: '0.8rem',
                marginTop: '10px'
              }}>
                Please correct the errors:
                {contactErrors.email && ` ${contactErrors.email}.`}
                {contactErrors.subject && ` ${contactErrors.subject}.`}
                {contactErrors.message && ` ${contactErrors.message}.`}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={this.toggleContactModal} disabled={isSubmittingContact}>
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={this.handleContactSubmit}
              disabled={!this.isContactFormValid() || isSubmittingContact}
              style={{ backgroundColor: '#434aad', borderColor: '#434aad' }}
            >
              {isSubmittingContact ? "Sending..." : "Send message"}
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
